<ng-container *ngIf="store$ | async"></ng-container>
